// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Clients Component Styles - Scoped to .clients-container */
.clients-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    sans-serif;
}

.clients-header {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  margin-bottom: 30px !important;
  padding: 20px 24px !important;
  border-radius: 16px !important;
  border: 1px solid rgba(229, 231, 235, 0.3) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
  backdrop-filter: blur(20px) !important;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(59, 130, 246, 0.1) 50%, rgba(147, 51, 234, 0.1) 100%) !important;
}

.clients-header h2 {
  margin: 0 !important;
  color: #000000 !important;
  font-size: 28px !important;
  font-weight: 700 !important;
}

.clients-actions {
  display: flex;
    gap: 10px;
  align-items: center;
}

.client-select {
  min-width: 250px !important;
  padding: 12px 16px !important;
  border: 2px solid rgba(229, 231, 235, 0.4) !important;
  border-radius: 12px !important;
  font-size: 14px !important;
  background: rgba(255, 255, 255, 0.8) !important;
  color: #374151 !important;
  cursor: pointer !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  backdrop-filter: blur(10px) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
}

.client-select:focus {
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1), 0 4px 12px rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.95);
}

.client-select:disabled {
  background: rgba(248, 249, 250, 0.8);
  color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.generate-summary-btn {
  padding: 12px 24px !important;
  background: linear-gradient(135deg, #10b981, #059669) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  white-space: nowrap !important;
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3) !important;
  backdrop-filter: blur(10px) !important;
}

.generate-summary-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669, #047857);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
}

.generate-summary-btn:disabled {
  background: rgba(156, 163, 175, 0.8);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
  opacity: 0.6;
}

.refresh-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 12px !important;
  padding: 10px 16px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #000000 !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  white-space: nowrap !important;
}

.refresh-btn:hover {
  background: rgba(255, 255, 255, 0.95);
  border-color: #10b981;
  color: #10b981;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

/* Loading Spinner */
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #6c757d;
  /* Ensure no transformations are inherited or applied to the container */
  transform: none !important;
  border: none !important; /* Remove any unwanted borders */
  box-shadow: none !important; /* Remove any unwanted box-shadows */
}

.spinner {
  width: 40px !important;
  height: 40px !important;
  border: 4px solid #e1e5e9 !important;
  border-top: 4px solid #3498db !important;
  border-radius: 50% !important;
  animation: clients-spinner-spin 1s linear infinite !important; /* Ensure animation runs */
  animation-play-state: running !important; /* Explicitly ensure animation is running */
  margin-bottom: 16px;
  transform-origin: center center; /* Ensure rotation is from the center */
  box-sizing: border-box !important; /* Ensure padding and border are included in the element's total width and height */
  flex-shrink: 0 !important; /* Prevent the spinner from shrinking */
}

/* Ensure the text does not inherit any rotation */
.loading-spinner p {
  transform: none !important;
}

.spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: clients-spinner-spin 1s linear infinite;
}

@keyframes clients-spinner-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Messages */
.message {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 500;
}

.message.error {
  background: linear-gradient(135deg, rgba(254, 226, 226, 0.9), rgba(252, 165, 165, 0.8));
  color: #991b1b;
  border: 1px solid rgba(239, 68, 68, 0.3);
  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.15);
  backdrop-filter: blur(10px);
}

.message.success {
  background: linear-gradient(135deg, rgba(209, 250, 229, 0.9), rgba(167, 243, 208, 0.8));
  color: #065f46;
  border: 1px solid rgba(16, 185, 129, 0.3);
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.2);
  animation: slideInDown 0.3s ease-out;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

.message.success::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #10b981, #059669);
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.close-btn:hover {
  opacity: 1;
}

/* No Clients State */
.no-clients {
  text-align: center;
  padding: 60px 20px;
  color: #6b7280;
  background: rgba(249, 250, 251, 0.8);
  border-radius: 16px;
  border: 2px dashed rgba(209, 213, 219, 0.6);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.no-clients p {
  margin: 0;
  font-size: 16px;
}

/* Clients Table Layout */
.clients-table-container {
  background: rgba(255, 255, 255, 0.9) !important;
  border-radius: 16px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
  overflow-x: auto !important;
  min-width: 1000px !important;
  border: 1px solid rgba(229, 231, 235, 0.3) !important;
  backdrop-filter: blur(20px) !important;
}

.clients-table {
  width: 100%;
  border-collapse: collapse;
}

.table-header {
  display: flex;
  background: linear-gradient(135deg, rgba(249, 250, 251, 0.8) 0%, rgba(243, 244, 246, 0.6) 100%);
  padding: 18px 0;
  border-bottom: 1px solid rgba(229, 231, 235, 0.3);
  font-weight: 700;
  color: #374151;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  align-items: center;
  width: 100%;
  backdrop-filter: blur(10px);
}

.header-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid rgba(229, 231, 235, 0.3);
  flex: 1 1;
}

.header-cell.name-cell {
  flex: 0 0 30%;
}

.header-cell.email-cell {
  flex: 0 0 22%;
}

.header-cell.summary-cell {
  flex: 0 0 30%;
}

.header-cell.actions-cell {
  flex: 0 0 18%;
}

.table-body {
  max-height: 600px;
  overflow-y: auto;
}

.table-row {
  display: grid;
  grid-template-columns: 2.5fr 2fr 2.5fr 1.5fr;
      gap: 10px;
  padding: 18px 16px;
  border-bottom: 1px solid rgba(241, 243, 244, 0.6);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  align-items: center;
  min-height: 60px;
  min-width: 1000px;
}

.table-row:hover {
  background: rgba(249, 250, 251, 0.6);
  backdrop-filter: blur(10px);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.table-row:last-child {
  border-bottom: none;
}


/* Summary Cell - Left align content to match header */
.summary-cell {
  justify-content: flex-start !important;
  text-align: left;
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
}

/* Actions Cell - Left align content to match header */
.actions-cell {
  justify-content: flex-start !important;
  text-align: left;
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
}


/* Remove border from last column */
.header-cell:last-child,
.table-cell:last-child {
  border-right: none;
}.table-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
  color: #374151;
  min-height: 24px;
  overflow: hidden;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid rgba(229, 231, 235, 0.2);
  flex: 1 1;
}

.table-cell.name-cell {
  flex: 0 0 30%;
}

.table-cell.email-cell {
  flex: 0 0 22%;
}

.table-cell.summary-cell {
  flex: 0 0 30%;
}

.table-cell.actions-cell {
  flex: 0 0 18%;
}

/* Name Cell */
.name-cell .client-name-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.name-cell .client-name {
  font-weight: 700;
  color: #111827;
  font-size: 15px;
}

.name-cell .client-details {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.name-cell .client-details span {
  color: #6c757d;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Email Cell */
.email-cell .client-email {
  color: #10b981;
  font-size: 14px;
  font-weight: 500;
  word-break: break-word;
  display: flex;
  align-items: center;
  min-height: 24px;
}

/* Status Cell */
.status-cell .status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.status-badge.active {
  background-color: #d4edda;
  color: #155724;
}

.status-badge.inactive {
  background-color: #f8d7da;
  color: #721c24;
}

.status-badge.archived {
  background-color: #e2e3e5;
  color: #383d41;
}

/* Summary Cell */
.summary-cell .summary-status-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  min-height: 24px;
}

.summary-cell .status-indicator {
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  display: inline-block;
  min-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-indicator.completed {
  background: linear-gradient(135deg, #d1fae5, #a7f3d0);
  color: #065f46;
  border: 1px solid rgba(16, 185, 129, 0.2);
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.1);
}

.status-indicator.pending {
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  color: #92400e;
  border: 1px solid rgba(245, 158, 11, 0.2);
  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.1);
}

.status-indicator.processing {
  background: linear-gradient(135deg, #dbeafe, #bfdbfe);
  color: #1e40af;
  border: 1px solid rgba(59, 130, 246, 0.2);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
}

.status-indicator.failed {
  background: linear-gradient(135deg, #fee2e2, #fecaca);
  color: #991b1b;
  border: 1px solid rgba(239, 68, 68, 0.2);
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.1);
}

.status-indicator.unknown {
  background-color: #e2e3e5;
  color: #383d41;
}

.status-indicator.none {
  background: rgba(249, 250, 251, 0.8);
  color: #6b7280;
  border: 1px solid rgba(209, 213, 219, 0.4);
  backdrop-filter: blur(5px);
}

.status-indicator.case-created {
  background: linear-gradient(135deg, #dcfce7, #bbf7d0);
  color: #166534;
  border: 1px solid rgba(34, 197, 94, 0.2);
  box-shadow: 0 2px 4px rgba(34, 197, 94, 0.1);
}

.status-indicator.case-creation-failed {
  background: linear-gradient(135deg, #fef2f2, #fee2e2);
  color: #dc2626;
  border: 1px solid rgba(239, 68, 68, 0.2);
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.1);
}

.status-indicator.form-submitted {
  background: linear-gradient(135deg, #fff7ed, #fed7aa);
  color: #ea580c;
  border: 1px solid rgba(251, 146, 60, 0.2);
  box-shadow: 0 2px 4px rgba(251, 146, 60, 0.1);
}

.status-indicator.under-review {
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  color: #2563eb;
  border: 1px solid rgba(59, 130, 246, 0.2);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
}

.status-indicator.client-contacted {
  background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
  color: #0369a1;
  border: 1px solid rgba(14, 165, 233, 0.2);
  box-shadow: 0 2px 4px rgba(14, 165, 233, 0.1);
}

.summary-cell .summary-date {
  font-size: 11px;
  color: #6c757d;
  display: block;
}



/* Actions Cell */
.actions-cell .summary-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  min-height: 24px;
}

.download-summary-btn {
  padding: 8px 16px;
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  min-width: 120px;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
  backdrop-filter: blur(10px);
}

.download-summary-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669, #047857);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.download-summary-btn:disabled {
  background: rgba(156, 163, 175, 0.8);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
  opacity: 0.6;
}

.error-details {
  font-size: 11px;
  color: #dc3545;
  max-width: 120px;
  word-break: break-word;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .clients-container {
    max-width: 100%;
    padding: 15px;
  }

  .table-header,
  .table-row {
    grid-template-columns: 2fr 2fr 2.5fr 1.5fr;
      gap: 10px;
    padding: 12px 16px;
  }

  .header-cell,
  .table-cell {
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .clients-table-container {
    overflow-x: auto;
    min-width: 900px;
  }

  .clients-table {
    min-width: 900px;
  }

  .table-header,
  .table-row {
    min-width: 900px;
    gap: 12px;
    padding: 10px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Clients.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb;cACY;AACd;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,qDAAqD;EACrD,qDAAqD;EACrD,sCAAsC;EACtC,qIAAqI;AACvI;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;IACX,SAAS;EACX,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,qDAAqD;EACrD,8BAA8B;EAC9B,0BAA0B;EAC1B,+CAA+C;EAC/C,yBAAyB;EACzB,0BAA0B;EAC1B,4DAA4D;EAC5D,sCAAsC;EACtC,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6EAA6E;EAC7E,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,gEAAgE;EAChE,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,4DAA4D;EAC5D,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;EAC9B,yDAAyD;EACzD,sCAAsC;AACxC;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,qDAAqD;EACrD,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,wEAAwE;EACxE,0BAA0B;EAC1B,uBAAuB,EAAE,gCAAgC;EACzD,2BAA2B,EAAE,oCAAoC;AACnE;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,wCAAwC;EACxC,6BAA6B;EAC7B,6DAA6D,EAAE,0BAA0B;EACzF,wCAAwC,EAAE,2CAA2C;EACrF,mBAAmB;EACnB,+BAA+B,EAAE,uCAAuC;EACxE,iCAAiC,EAAE,mFAAmF;EACtH,yBAAyB,EAAE,uCAAuC;AACpE;;AAEA,kDAAkD;AAClD;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uFAAuF;EACvF,cAAc;EACd,wCAAwC;EACxC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,uFAAuF;EACvF,cAAc;EACd,yCAAyC;EACzC,8CAA8C;EAC9C,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,+CAA+C;EAC/C,8BAA8B;EAC9B,qDAAqD;EACrD,2BAA2B;EAC3B,4BAA4B;EAC5B,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,+FAA+F;EAC/F,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,gDAAgD;EAChD,SAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4CAA4C;MACxC,SAAS;EACb,kBAAkB;EAClB,iDAAiD;EACjD,iDAAiD;EACjD,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,sDAAsD;AACtD;EACE,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;AACb;;AAEA,sDAAsD;AACtD;EACE,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;AACb;;;AAGA,mCAAmC;AACnC;;EAEE,kBAAkB;AACpB,CAAC;EACC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,gDAAgD;EAChD,SAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,eAAe;AACf;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;;;AAIA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,aAAa;EACf;;EAEA;;IAEE,0CAA0C;MACxC,SAAS;IACX,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,SAAS;IACT,kBAAkB;EACpB;AACF","sourcesContent":["/* Clients Component Styles - Scoped to .clients-container */\n.clients-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\",\n    sans-serif;\n}\n\n.clients-header {\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n  margin-bottom: 30px !important;\n  padding: 20px 24px !important;\n  border-radius: 16px !important;\n  border: 1px solid rgba(229, 231, 235, 0.3) !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;\n  backdrop-filter: blur(20px) !important;\n  background: linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(59, 130, 246, 0.1) 50%, rgba(147, 51, 234, 0.1) 100%) !important;\n}\n\n.clients-header h2 {\n  margin: 0 !important;\n  color: #000000 !important;\n  font-size: 28px !important;\n  font-weight: 700 !important;\n}\n\n.clients-actions {\n  display: flex;\n    gap: 10px;\n  align-items: center;\n}\n\n.client-select {\n  min-width: 250px !important;\n  padding: 12px 16px !important;\n  border: 2px solid rgba(229, 231, 235, 0.4) !important;\n  border-radius: 12px !important;\n  font-size: 14px !important;\n  background: rgba(255, 255, 255, 0.8) !important;\n  color: #374151 !important;\n  cursor: pointer !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  backdrop-filter: blur(10px) !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;\n}\n\n.client-select:focus {\n  outline: none;\n  border-color: #10b981;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1), 0 4px 12px rgba(0, 0, 0, 0.08);\n  background: rgba(255, 255, 255, 0.95);\n}\n\n.client-select:disabled {\n  background: rgba(248, 249, 250, 0.8);\n  color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.generate-summary-btn {\n  padding: 12px 24px !important;\n  background: linear-gradient(135deg, #10b981, #059669) !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 12px !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  cursor: pointer !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  white-space: nowrap !important;\n  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3) !important;\n  backdrop-filter: blur(10px) !important;\n}\n\n.generate-summary-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #059669, #047857);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);\n}\n\n.generate-summary-btn:disabled {\n  background: rgba(156, 163, 175, 0.8);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n  opacity: 0.6;\n}\n\n.refresh-btn {\n  background: rgba(255, 255, 255, 0.1) !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  border-radius: 12px !important;\n  padding: 10px 16px !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  color: #000000 !important;\n  cursor: pointer !important;\n  transition: all 0.3s ease !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  white-space: nowrap !important;\n}\n\n.refresh-btn:hover {\n  background: rgba(255, 255, 255, 0.95);\n  border-color: #10b981;\n  color: #10b981;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n/* Loading Spinner */\n.loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #6c757d;\n  /* Ensure no transformations are inherited or applied to the container */\n  transform: none !important;\n  border: none !important; /* Remove any unwanted borders */\n  box-shadow: none !important; /* Remove any unwanted box-shadows */\n}\n\n.spinner {\n  width: 40px !important;\n  height: 40px !important;\n  border: 4px solid #e1e5e9 !important;\n  border-top: 4px solid #3498db !important;\n  border-radius: 50% !important;\n  animation: clients-spinner-spin 1s linear infinite !important; /* Ensure animation runs */\n  animation-play-state: running !important; /* Explicitly ensure animation is running */\n  margin-bottom: 16px;\n  transform-origin: center center; /* Ensure rotation is from the center */\n  box-sizing: border-box !important; /* Ensure padding and border are included in the element's total width and height */\n  flex-shrink: 0 !important; /* Prevent the spinner from shrinking */\n}\n\n/* Ensure the text does not inherit any rotation */\n.loading-spinner p {\n  transform: none !important;\n}\n\n.spinner-small {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: clients-spinner-spin 1s linear infinite;\n}\n\n@keyframes clients-spinner-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Messages */\n.message {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.message.error {\n  background: linear-gradient(135deg, rgba(254, 226, 226, 0.9), rgba(252, 165, 165, 0.8));\n  color: #991b1b;\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.15);\n  backdrop-filter: blur(10px);\n}\n\n.message.success {\n  background: linear-gradient(135deg, rgba(209, 250, 229, 0.9), rgba(167, 243, 208, 0.8));\n  color: #065f46;\n  border: 1px solid rgba(16, 185, 129, 0.3);\n  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.2);\n  animation: slideInDown 0.3s ease-out;\n  position: relative;\n  overflow: hidden;\n  backdrop-filter: blur(10px);\n}\n\n.message.success::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n  background: linear-gradient(135deg, #10b981, #059669);\n}\n\n@keyframes slideInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n}\n\n.close-btn:hover {\n  opacity: 1;\n}\n\n/* No Clients State */\n.no-clients {\n  text-align: center;\n  padding: 60px 20px;\n  color: #6b7280;\n  background: rgba(249, 250, 251, 0.8);\n  border-radius: 16px;\n  border: 2px dashed rgba(209, 213, 219, 0.6);\n  backdrop-filter: blur(10px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.no-clients p {\n  margin: 0;\n  font-size: 16px;\n}\n\n/* Clients Table Layout */\n.clients-table-container {\n  background: rgba(255, 255, 255, 0.9) !important;\n  border-radius: 16px !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;\n  overflow-x: auto !important;\n  min-width: 1000px !important;\n  border: 1px solid rgba(229, 231, 235, 0.3) !important;\n  backdrop-filter: blur(20px) !important;\n}\n\n.clients-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table-header {\n  display: flex;\n  background: linear-gradient(135deg, rgba(249, 250, 251, 0.8) 0%, rgba(243, 244, 246, 0.6) 100%);\n  padding: 18px 0;\n  border-bottom: 1px solid rgba(229, 231, 235, 0.3);\n  font-weight: 700;\n  color: #374151;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  align-items: center;\n  width: 100%;\n  backdrop-filter: blur(10px);\n}\n\n.header-cell {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 24px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0 20px;\n  box-sizing: border-box;\n  border-right: 1px solid rgba(229, 231, 235, 0.3);\n  flex: 1;\n}\n\n.header-cell.name-cell {\n  flex: 0 0 30%;\n}\n\n.header-cell.email-cell {\n  flex: 0 0 22%;\n}\n\n.header-cell.summary-cell {\n  flex: 0 0 30%;\n}\n\n.header-cell.actions-cell {\n  flex: 0 0 18%;\n}\n\n.table-body {\n  max-height: 600px;\n  overflow-y: auto;\n}\n\n.table-row {\n  display: grid;\n  grid-template-columns: 2.5fr 2fr 2.5fr 1.5fr;\n      gap: 10px;\n  padding: 18px 16px;\n  border-bottom: 1px solid rgba(241, 243, 244, 0.6);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  align-items: center;\n  min-height: 60px;\n  min-width: 1000px;\n}\n\n.table-row:hover {\n  background: rgba(249, 250, 251, 0.6);\n  backdrop-filter: blur(10px);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.table-row:last-child {\n  border-bottom: none;\n}\n\n\n/* Summary Cell - Left align content to match header */\n.summary-cell {\n  justify-content: flex-start !important;\n  text-align: left;\n  padding: 0 !important;\n  margin: 0 !important;\n  width: 100%;\n}\n\n/* Actions Cell - Left align content to match header */\n.actions-cell {\n  justify-content: flex-start !important;\n  text-align: left;\n  padding: 0 !important;\n  margin: 0 !important;\n  width: 100%;\n}\n\n\n/* Remove border from last column */\n.header-cell:last-child,\n.table-cell:last-child {\n  border-right: none;\n}.table-cell {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  font-size: 14px;\n  color: #374151;\n  min-height: 24px;\n  overflow: hidden;\n  padding: 0 20px;\n  box-sizing: border-box;\n  border-right: 1px solid rgba(229, 231, 235, 0.2);\n  flex: 1;\n}\n\n.table-cell.name-cell {\n  flex: 0 0 30%;\n}\n\n.table-cell.email-cell {\n  flex: 0 0 22%;\n}\n\n.table-cell.summary-cell {\n  flex: 0 0 30%;\n}\n\n.table-cell.actions-cell {\n  flex: 0 0 18%;\n}\n\n/* Name Cell */\n.name-cell .client-name-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.name-cell .client-name {\n  font-weight: 700;\n  color: #111827;\n  font-size: 15px;\n}\n\n.name-cell .client-details {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.name-cell .client-details span {\n  color: #6c757d;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Email Cell */\n.email-cell .client-email {\n  color: #10b981;\n  font-size: 14px;\n  font-weight: 500;\n  word-break: break-word;\n  display: flex;\n  align-items: center;\n  min-height: 24px;\n}\n\n/* Status Cell */\n.status-cell .status-badge {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n}\n\n.status-badge.active {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.status-badge.inactive {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.status-badge.archived {\n  background-color: #e2e3e5;\n  color: #383d41;\n}\n\n/* Summary Cell */\n.summary-cell .summary-status-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n  min-height: 24px;\n}\n\n.summary-cell .status-indicator {\n  padding: 4px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  white-space: nowrap;\n  display: inline-block;\n  min-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.status-indicator.completed {\n  background: linear-gradient(135deg, #d1fae5, #a7f3d0);\n  color: #065f46;\n  border: 1px solid rgba(16, 185, 129, 0.2);\n  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.1);\n}\n\n.status-indicator.pending {\n  background: linear-gradient(135deg, #fef3c7, #fde68a);\n  color: #92400e;\n  border: 1px solid rgba(245, 158, 11, 0.2);\n  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.1);\n}\n\n.status-indicator.processing {\n  background: linear-gradient(135deg, #dbeafe, #bfdbfe);\n  color: #1e40af;\n  border: 1px solid rgba(59, 130, 246, 0.2);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);\n}\n\n.status-indicator.failed {\n  background: linear-gradient(135deg, #fee2e2, #fecaca);\n  color: #991b1b;\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.1);\n}\n\n.status-indicator.unknown {\n  background-color: #e2e3e5;\n  color: #383d41;\n}\n\n.status-indicator.none {\n  background: rgba(249, 250, 251, 0.8);\n  color: #6b7280;\n  border: 1px solid rgba(209, 213, 219, 0.4);\n  backdrop-filter: blur(5px);\n}\n\n.status-indicator.case-created {\n  background: linear-gradient(135deg, #dcfce7, #bbf7d0);\n  color: #166534;\n  border: 1px solid rgba(34, 197, 94, 0.2);\n  box-shadow: 0 2px 4px rgba(34, 197, 94, 0.1);\n}\n\n.status-indicator.case-creation-failed {\n  background: linear-gradient(135deg, #fef2f2, #fee2e2);\n  color: #dc2626;\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.1);\n}\n\n.status-indicator.form-submitted {\n  background: linear-gradient(135deg, #fff7ed, #fed7aa);\n  color: #ea580c;\n  border: 1px solid rgba(251, 146, 60, 0.2);\n  box-shadow: 0 2px 4px rgba(251, 146, 60, 0.1);\n}\n\n.status-indicator.under-review {\n  background: linear-gradient(135deg, #eff6ff, #dbeafe);\n  color: #2563eb;\n  border: 1px solid rgba(59, 130, 246, 0.2);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);\n}\n\n.status-indicator.client-contacted {\n  background: linear-gradient(135deg, #f0f9ff, #e0f2fe);\n  color: #0369a1;\n  border: 1px solid rgba(14, 165, 233, 0.2);\n  box-shadow: 0 2px 4px rgba(14, 165, 233, 0.1);\n}\n\n.summary-cell .summary-date {\n  font-size: 11px;\n  color: #6c757d;\n  display: block;\n}\n\n\n\n/* Actions Cell */\n.actions-cell .summary-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 24px;\n}\n\n.download-summary-btn {\n  padding: 8px 16px;\n  background: linear-gradient(135deg, #10b981, #059669);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n  min-width: 120px;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);\n  backdrop-filter: blur(10px);\n}\n\n.download-summary-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #059669, #047857);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n.download-summary-btn:disabled {\n  background: rgba(156, 163, 175, 0.8);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n  opacity: 0.6;\n}\n\n.error-details {\n  font-size: 11px;\n  color: #dc3545;\n  max-width: 120px;\n  word-break: break-word;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .clients-container {\n    max-width: 100%;\n    padding: 15px;\n  }\n\n  .table-header,\n  .table-row {\n    grid-template-columns: 2fr 2fr 2.5fr 1.5fr;\n      gap: 10px;\n    padding: 12px 16px;\n  }\n\n  .header-cell,\n  .table-cell {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 768px) {\n  .clients-table-container {\n    overflow-x: auto;\n    min-width: 900px;\n  }\n\n  .clients-table {\n    min-width: 900px;\n  }\n\n  .table-header,\n  .table-row {\n    min-width: 900px;\n    gap: 12px;\n    padding: 10px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
